import DynamicPages, { DynamicPagesProps } from '@components/pages/dynamic'

type StoryTellingProps = {
  data: DynamicPagesProps['page']
  handle: string
}

const StoryTelling = ({ data, handle }: StoryTellingProps) => {
  return <DynamicPages page={data} handle={`/products/${handle}`} />
}

export default StoryTelling
